@if (notes) {
<alert-bar [noIcon]="true">{{ notes }}</alert-bar>
}
